<template>
    <v-card v-show="!$store.getters.progress" :elevation="1" class="round-card background-2" width="100%" height="100%">

        <v-col ref="googleMap" id="map" class="round-card" style="min-height: 350px; height: 100%;"></v-col>

    </v-card>
</template>

<script>

    import GoogleMapsApiLoader from 'google-maps-api-loader'
    import HTMLMarker from '@/components/utilities/HTMLMarker.js'

    export default {
        name: 'show-map',
        props: {
            model: Object,
        },

        data() {
            return {
                apiKey: 'AIzaSyBfzJUosHsruxGnozq51-cz7YkAbf4RhqA',
                markers: [],
                currentPlace: null,
                google: null,
                map: null,
                icons: null,
                mapConfig: {
                    center: { lat: 41.9102411, lng: 12.3955718 },
                    zoom: 12,
                    mapTypeId: 'roadmap',
                    mapTypeControl: false,
                },
                logoBase64: ''
            }
        },
        
        async mounted() {

            let address_lat = this.$store.getters.getSetting('address_lat')
            let address_lng = this.$store.getters.getSetting('address_lng')

            this.$set(this.mapConfig.center, 'lat', parseFloat(this.model.legal_address_lat))
            this.$set(this.mapConfig.center, 'lng', parseFloat(this.model.legal_address_lng))

            const googleMapApi = await GoogleMapsApiLoader({
                apiKey: this.apiKey,
                libraries: ['places']
            })
            this.google = googleMapApi

            const mapContainer = this.$refs.googleMap

            this.map = new this.google.maps.Map(mapContainer, this.mapConfig)
            this.google.maps.event.trigger(this.map, 'resize')

            const iconBase = '/img/icons/pin_'
            this.icons = {
                lead: {
                    name: 'Lead',
                    icon: iconBase + 'lead.svg',
                },
                prospect: {
                    name: 'Prospect',
                    icon: iconBase + 'prospect.svg',
                },
                customer: {
                    name: 'Cliente',
                    icon: iconBase + 'customer.svg',
                },
            }

            let m = new this.google.maps.Marker({
                position: {'lat': parseFloat(this.model.legal_address_lat), 'lng': parseFloat(this.model.legal_address_lng)},
                map: this.map,
                icon: this.icons[this.model.company_status].icon
            })

            this.markers.push(m)

            if(address_lat && address_lng) {

                const googleApi = this.google
                const currentMap = this.map

                this.axios.get('get-logo').then(response => {

                    this.logoBase64 = response.data.logo

                    HTMLMarker.prototype = new googleApi.maps.OverlayView()
                    HTMLMarker.prototype.onRemove= function(){}

                    //init html element
                    let logo = this.logoBase64
                    HTMLMarker.prototype.onAdd= function(){
                        var div = document.createElement('div')
                        div.classList.add('arrow_box', 'custom-avatar')
                        div.style.cssText = 'background-image: url("' + logo + '"); border-radius: 50% !important; background-size: contain !important; background-position: center !important'

                        var panes = this.getPanes()
                        panes.overlayImage.appendChild(div)
                    }

                    HTMLMarker.prototype.draw = function(){
                        var overlayProjection = this.getProjection()
                        var position = overlayProjection.fromLatLngToDivPixel(this.pos)
                        var panes = this.getPanes()
                        panes.overlayImage.style.left = position.x + 'px'
                        panes.overlayImage.style.top = position.y - 30 + 'px'
                    }

                    var htmlMarker = new HTMLMarker(address_lat, address_lng)
                    htmlMarker.setMap(currentMap)

                }, response => {
                    // error callback
                })
            }
        },
    }
</script>

<style>
    button.gm-ui-hover-effect {
        display: none !important;
    }
    .gm-style-iw.gm-style-iw-c {
        padding: 0px !important;
        border-radius: 4px !important;
        min-width: 310px !important;
        font-weight: normal !important;
    }
                    
    .gm-style-iw-d {
        overflow: auto !important
    }
    div >>> .v-list__tile {
        height: 42px;
        -webkit-user-select: auto;
        user-select: auto;
    }
    .gm-style-mtc > div {
        height: 36px !important;
        font-size: 14px !important;
    }
    .gm-style-mtc div {
        font-size: 14px !important;
        box-sizing: border-box;
    }
    .gm-control-active.gm-fullscreen-control {
        height: 34px !important;
        width: 34px !important;
    }
    .gm-control-active.gm-fullscreen-control > img {
        height: 14px !important;
        width: 14px !important;
    }
    button.gm-control-active {
        height: 34px !important;
        width: 34px !important;
    }
    .gm-control-active > img {
        height: 14px !important;
        width: 14px !important;
    }
    .gmnoprint.gm-bundled-control.gm-bundled-control-on-bottom > .gmnoprint > div {
        width: 34px !important;
        height: 69px !important;
    }
    .gm-svpc {
        height: 34px !important;
        width: 34px !important;
        top: 10px !important;
    }
    .gm-svpc > div > img {
        height: 22px !important;
        width: 22px !important;
    }

    /*******************HTML MARKER */

    div.arrow_box{
        width: 50px;
        height: 50px;
        border-radius: 50%;
        margin: -50px 0px;
        border: solid 3px #ffc107 !important;
        cursor: pointer;
        overflow: hidden;
    }
    div.arrow_box img{
        min-width:50px;
        width:auto;
        max-height:50px;
        height:auto;
    }
    .arrow_box:after {
        top: 5px;
        left: 9px;
        border: solid transparent;
        content: " ";
        height: 0;
        width: 0;
        position: absolute;
        pointer-events: none;
        border-color: rgba(136, 183, 213, 0);
        border-top-color: #ffc107 !important;
        border-width: 16px;
        margin-left: 0px;
    }
</style>